import { Button } from "@common/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@common/components/ui/dropdown-menu"
import { ArrowDown, ArrowUp, MoreVertical, Pencil } from "lucide-react"
import ArchiveOutline from "~icons/material-symbols/archive-outline"

export function PhaseMenu({
  name,
  first,
  last,
  disabled,
  onRename,
  onMove,
  onDelete,
}: {
  name: string
  first: boolean
  last: boolean
  disabled: boolean
  onRename: () => void
  onMove: (offset: -1 | 1) => void
  onDelete: () => void
}): React.ReactElement {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-xs"
          aria-label={`${name} actions`}
          disabled={disabled}
        >
          <MoreVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onRename}>
          <Pencil className="size-4" />
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem disabled={first} onSelect={() => onMove(-1)}>
          <ArrowUp className="size-4" />
          Move up
        </DropdownMenuItem>
        <DropdownMenuItem disabled={last} onSelect={() => onMove(1)}>
          <ArrowDown className="size-4" />
          Move down
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onDelete}>
          <ArchiveOutline className="size-4" />
          Archive
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
